import { useCallback, useMemo } from "react";

import { Filter, FilterId, FilterType } from "@/Components/v2/organism/Header/Header";
import { useInfo } from "@/context/InfoProvider/InfoProvider";
import { useFinancialStore } from "@/pages/financial-review/store";

export const useAvailableFilters = () => {
  const { setTargetNodeUUID, setGeographies } = useFinancialStore();
  const { targetNodeUUID, filters } = useFinancialStore((state) => state);
  const { initInfo: info } = useInfo();
  const [geoData] = info?.geographies || [];

  const handleTargetNodeChange = useCallback(
    (targetNode: string | null) => {
      setTargetNodeUUID(targetNode);
    },
    [setTargetNodeUUID]
  );

  const handleGeographiesChange = useCallback(
    (geography: string[]) => setGeographies(geography),
    [setGeographies]
  );

  // Memoize each filter option separately
  const targetNodeFilter = useMemo(
    () => ({
      id: FilterId.BusinessUnit,
      label: "Business Unit",
      type: FilterType.BusinessUnit,
      value: targetNodeUUID,
      onChange: handleTargetNodeChange,
    }),
    [targetNodeUUID, handleTargetNodeChange]
  );

  const geographiesFilter = useMemo(
    () => ({
      id: FilterId.Geography,
      label: "Geo",
      type: FilterType.MultiSelect,
      value: filters.geographies,
      onChange: handleGeographiesChange,
    }),
    [filters.geographies, handleGeographiesChange]
  );
  return useMemo(() => {
    const filters: Filter[] = [targetNodeFilter];
    if (geoData && geoData.length > 0) {
      filters.push(geographiesFilter);
    }
    return filters;
  }, [targetNodeFilter, geographiesFilter, geoData]);
};
